export default{
    all: {},
    loading: false,
    error: "",
    preview: {},
    linkPromotion: ""
}